<script>
import { BAvatar } from "bootstrap-vue"

export default {
  components: {
    BAvatar,
  },
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <BAvatar
        :variant="variant"
        size="2rem"
        class="mr-75 flex-shrink-0 rounded-5"
      >
        <feather-icon
          :icon="icon"
          :class="{ 'text-white': variant === 'success' }"
          class="toastification-icon"
        />
      </BAvatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small
            v-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto"
          @click="$emit('close-toast')"
        >
          <feather-icon
            v-if="!hideClose"
            icon="XIcon"
            class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}

.toastification-icon {
  width: 30px !important;
  height: 30px !important;
}
</style>
